var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "flex-grow w-max" },
    [
      _c("dropdown-component", {
        attrs: { values: _vm.values, value: _vm.dropDownValue },
        on: { input: _vm.changeHandler },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }